@keyframes slideLeft {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes slideRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes slideTop {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slideBottom {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.backdrop {
  position: fixed;
  inset: 0;
  background-color: var(--tuna-palette-backdrop);
  z-index: var(--tuna-zIndex-drawer);
  -webkit-tap-highlight-color: transparent;
  animation: tuna-backdrop-fade-in 150ms ease-out;
}

.drawer {
  position: fixed;
  z-index: var(--tuna-zIndex-drawer);
  background-color: var(--tuna-palette-background-paper);
  color: var(--tuna-palette-text-primary);
  box-shadow:
    0 8px 10px -5px rgba(0, 0, 0, 0.2),
    0 16px 24px 2px rgba(0, 0, 0, 0.14),
    0 6px 30px 5px rgba(0, 0, 0, 0.12);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  outline: 0;
}

.left {
  top: 0;
  bottom: 0;
  left: 0;
  animation: slideLeft 225ms ease-out;
}

.right {
  top: 0;
  bottom: 0;
  right: 0;
  animation: slideRight 225ms ease-out;
}

.top {
  top: 0;
  left: 0;
  right: 0;
  animation: slideTop 225ms ease-out;
}

.bottom {
  bottom: 0;
  left: 0;
  right: 0;
  animation: slideBottom 225ms ease-out;
}

@media (prefers-reduced-motion: reduce) {
  .drawer,
  .backdrop {
    animation: none !important;
  }
}
